import { TabPanel, TabView } from 'primereact/tabview'
import DashboardSection from './DashboardTabs/DashboardSection';


const Dashboard = () => {

  return (
    <div className="m-5 dashboard-container">

      {/* <TabView scrollable className='mt-4'>
        <TabPanel header="Dashboard"> */}
          <DashboardSection />
        {/* </TabPanel>

      </TabView> */}
    </div>
  )
}

export default Dashboard